<template>
  <div
    :class="getClass()"
    @click="this.handleClick"
    :style="this.small ? 'padding: 12px 12px;' : 'padding: 18px 10px;'"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "RadioGroupItem",
  props: {
    label: String,
    selected: Boolean,
    positive: Boolean,
    click: null,
    small: Boolean,

    error: Boolean,
    secondary: Boolean,
    tertiary: Boolean,
    secondaryLighten: Boolean,
    gray: Boolean
  },
  methods: {
    getClass() {
      let result = "radio-group-item";

      if (this.selected != null && this.selected === true) {
        result += " selected";

        if (this.positive) result += " positive";
        if (this.error) result += " error";
        if (this.secondary) result += " secondary-aev";
        if (this.tertiary) result += " tertiary";
        if (this.secondaryLighten) result += " secondary-lighten";
        if (this.gray) result += " gray";
      }

      return result;
    },
    handleClick() {
      if (this.click != null) {
        this.click.call();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../utils/assets/stylesheets/variables.scss";

.radio-group-item {
  border-radius: $border-radius;
  padding: 18px 10px;

  box-sizing: border-box;
  text-align: center;
  cursor: pointer;
  width: 100%;
  user-select: none;
  font-size: 1em;

  border: 1px solid $gray-lighten-1;
  color: $primary-lighten-1;
  background-color: white;

  &.selected {
    background-color: $gray-lighten-2;
    color: $primary;
    font-weight: 500;
    border: 1px solid $gray-lighten-2;
    transition: all 200ms cubic-bezier(0.21, 1.05, 0.83, 0.67);
  }
  &.positive {
    background-color: $positive;
    color: white;
    font-weight: 600;
    border: 1px solid $positive;
    transition: all 200ms cubic-bezier(0.21, 1.05, 0.83, 0.67);
  }
  &.error {
    background-color: $error;
    color: white;
    font-weight: 600;
    border: 1px solid $error;
    transition: all 200ms cubic-bezier(0.21, 1.05, 0.83, 0.67);
  }
  &.secondary-aev {
    background-color: $secondary;
    color: white;
    font-weight: 600;
    border: 1px solid $secondary;
    transition: all 200ms cubic-bezier(0.21, 1.05, 0.83, 0.67);
  }
  &.secondary-lighten {
    background-color: $secondary-lighten-4;
    color: $secondary;
    font-weight: 600;
    border: 1px solid $secondary-lighten-4;
    transition: all 200ms cubic-bezier(0.21, 1.05, 0.83, 0.67);
  }
  &.tertiary {
    background-color: darken($tertiary, 12%);
    color: white;
    font-weight: 600;
    border: 1px solid darken($tertiary, 12%);
    transition: all 200ms cubic-bezier(0.21, 1.05, 0.83, 0.67);
  }
  &.gray {
    background-color: $gray-lighten-2;
    color: $primary;
    font-weight: 600;
    border: 1px solid $gray-lighten-2;
    transition: all 200ms cubic-bezier(0.21, 1.05, 0.83, 0.67);
  }
}
</style>
